import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=6b074fd2&"
import script from "./Offer.vue?vue&type=script&lang=js&"
export * from "./Offer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DocumentContent: require('/home/bitrix/frontend/components/other/DocumentContent.vue').default,Preloader: require('/home/bitrix/frontend/components/other/Preloader.vue').default})
